import React from "react";

const Confirmation = ({ modal_id, children, handleSubmit }) => {
  return (
    <div
      class='modal fade'
      id={modal_id}
      tabindex='-1'
      aria-labelledby=''
      aria-hidden='true'
    >
      <div class='modal-dialog'>
        <div class='modal-content'>
          <div class='modal-body'>{children}</div>
          <div class='modal-footer d-flex justify-content-between'>
            <button
              type='button'
              class='btn btn-sm btn-secondary px-4 ms-4'
              data-bs-dismiss='modal'
            >
              No
            </button>
            <button
              type='button'
              class='ms-5 btn btn-sm btn-primary px-4'
              data-bs-dismiss='modal'
              onClick={() => handleSubmit()}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
